<script>
import { BuildingComplexesService } from '@/services/building-complexes.service';
import BaseAutocompleteFilter from './BaseAutocompleteFilter';

export default {
  name: 'BusinessCustomersFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    getData() {
      BuildingComplexesService.getFilteredBusinessCustomers({
        search: this.search,
      }).then(({ data }) => {
        this.items = data;
      });
    },
  },
};
</script>
